<template>
  <v-card
    v-if='mode="resetPassword"'
    width='500px'>
    <v-card-text class="headline font-weight-bold">
      Reset Password
        <v-form ref='form' v-model="valid">
          <v-text-field
            v-model='newpassword'
            :append-icon="showPW ? 'visibility' : 'visibility_off'"
            @click:append="showPW = !showPW"
            :type="showPW ? 'text' : 'password'"
            :rules='fieldRules'
            class='mt-5'
            label="Enter your new password"
            outline
            required></v-text-field>
        </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn class='mb-2' @click='handleResetPassword' :disabled="!valid" block rounded color="primary">Reset</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapFields } from 'vuex-map-fields';
  export default {
    data() {
      return{
        showPW: false,
        valid : true,
        fieldRules : [ v => !!v || 'this field is required',
        v => (v && v.length >= 6) || 'password must be greater than 6 characters'],
        mode : this.$route.query.mode,
        oobCode : this.$route.query.oobCode,
        apiKey : this.$route.query.apiKey,
        lang : this.$route.query.apiKey,
        newpassword : "",
      }
    },
    computed : {
      ...mapFields([
        'snackBarshow',
        'snackBarType',
        'snackBarmessage',
      ]),
    },
    mounted(){
      switch (this.$route.query.mode) {
        case 'resetPassword':
          // Display reset password handler and UI.
          // this.handleResetPassword(this.mode, this.oobCode, this.apiKey, this.lang,this.newpassword);
          break;
        case 'recoverEmail':
          // Display email recovery handler and UI.
          // handleRecoverEmail(auth, actionCode, lang);
          break;
        case 'verifyEmail':
          // Display email verification handler and UI.
          // handleVerifyEmail(auth, actionCode, continueUrl, lang);
          break;
        default:
          // Error: invalid mode.
      }
    },
    methods : {
      handleResetPassword(){
        const payload = {"oobCode":this.oobCode,"newPassword":this.newpassword}
        const url = "https://www.googleapis.com/identitytoolkit/v3/relyingparty/resetPassword?key="+this.apiKey
        //confrim the password change
        this.$axios
          .post(url,payload)
          .then(() => {
              this.snackBarType = "success"
              this.snackBarshow =true
              this.snackBarmessage = "Password reset complete, you may now close this window."
              this.newpassword = ""
            })
          .catch(() => {
              this.snackBarType = "warning"
              this.snackBarshow =true
              this.snackBarmessage = "Error"
          })
      }
    },
  }
</script>
